









































































































































































































import settings from '@/settings'
import n from '@/utils/notifications'
import t from '@/utils/tools'
import q from '@/graphql/query'
import m from '@/graphql/mutation'
import d from '@/utils/imports'
import af from '@/utils/authorized_formats'

export default {
    name: 'users_profile'

    props: {
        uid: {
            type: String
        }
    }
    
    data: ()->
        photo_url: ''
        loading: true
        true: true
        false: false
        errors: {}
        social_nbr_error: ['Le numéro de sécurité sociale doit contenir 15 chiffres']
        clearable: true
        picker_options: {firstDayOfWeek:1}
        max_filesize: af['user_info']['photo']['max_filesize']/1024/1024
        authorized_formats: af['user_info']['photo']['authorized_formats']
        managers: []
        roles: []
        initial_is_active: true
        initial_email: ''
        user: {
            uid: ''
            parent: {uid:'', fullname:'Aucun'}
            roles: []
            email: ''
            tracker: ''
            ical: ''
            is_active: true
            is_activated: false
            is_archived: false
            user_info: {
                uid: ''
                gender: false
                lastname: ''
                firstname: ''
                birthday: ''
                nationality: ''
                title_of_stay: false
                title_of_stay_name: ''
                title_of_stay_number: ''
                title_of_stay_validity: ''
                address: ''
                address2: ''
                zipcode: ''
                city: ''
                phone: ''
                social_nbr: ''
                medical_visit: ''
                sir: false
                rqth: false
                rqth_end: ''
                photo_name: ''
                photo_data: ''
                opco: ''
                reference: ''
            }
        }

    computed:
        is_activated: ()->
            if @user.is_activated
                return 'Oui'
            return 'Non'

        user_is_logged_user: ()->
            return @uid == @$store.state.user_datas.app_user.uid

        leader_only: ()->
            if @$store.state.user_datas.profiles.indexOf('leader') != -1
                return true
            return false

        readonly: ()->
            if @$route.name == 'company_users_profile'
                return !@has_access_right('users_edit')
            else
                if @uid != @$store.state.user_datas.app_user.uid
                    return true
                else
                    return !@has_access_right('users_self_edit')

        ref_readonly: ()->
            return !t.has_access_right(d['users']['access_set'][0])

    methods:
        has_access_right: t.has_access_right

        telephone_change: ()->
            @user.user_info.phone = t.phone_format(@user.user_info.phone)
            return

        social_nbr_change: ()->
            # console.log "SOCIAL ", @user.user_info.social_nbr.length
            # console.log "SOCIAL ", Object.keys(@errors).indexOf('social_nbr')
            # console.log "SOCIAL ", isNaN(@user.user_info.social_nbr)
            if @user.user_info.social_nbr.length > 0 and isNaN(@user.user_info.social_nbr)
                @errors['social_nbr'] = @social_nbr_error
                return
            if @user.user_info.social_nbr.length > 0 and @user.user_info.social_nbr.length != 15 and Object.keys(@errors).indexOf('social_nbr') == -1
                @errors['social_nbr'] = @social_nbr_error
            if (@user.user_info.social_nbr.length == 15 or @user.user_info.social_nbr.length == 0) and Object.keys(@errors).indexOf('social_nbr') != -1
                delete @errors['social_nbr']
            return

        is_archived_changed: ()->
            if @user.is_archived
                @user.is_active = false
            else
                @user.is_active = true
            return

        handle_image_remove: (file, fileList)->
            @photo_url = ''
            @user.user_info.photo_data = ''
            @user.user_info.photo_name = ''
            return

        handle_image_change: (file, fileList)->
            is_good_ext = file.raw.type in af['user_info']['photo']['mime_types']
            is_good_size = file.size < af['user_info']['photo']['max_filesize']

            if !is_good_ext
                n.file_error('Erreur', 'La photo doit être une image de type '+@authorized_formats+'.')
                return
            if !is_good_size
                n.file_error('Erreur', 'La photo ne peut pas excéder '+@max_filesize+'Mo.')
                return

            self = @
            @photo_url = URL.createObjectURL(file.raw)
            # console.log "URL", @photo_url
            reader = new FileReader()
            reader.onload = (e)->
                # console.log 'E', e
                self.user.user_info.photo_data = e.target.result
                self.user.user_info.photo_name = file.name
            reader.readAsDataURL(file.raw)
            # console.log "IMAGE", @user.user_info
            return

        open_alert: ()->
            @$confirm('Merci de vous rapprocher de votre expert-comptable ou responsable RH afin
                de vérifier la conformité de l’autorisation de travail', 'Information', {
                    confirmButtonText: 'OK'
                    showCancelButton: false
                })
                .then ()->
                    return
                .catch ()->
                    return

        get_errors: (fieldName)->
            ret = null
            if @errors[fieldName]?
                ret = @errors[fieldName][0]
            return ret

        resend_activation_email: ()->
            user_is_active = false
            if @user.is_active
                user_is_active = true
            user_is_not_activated = !@user.is_activated
            if @initial_email != @user.email or @initial_is_active == !user_is_active
                n.warning("Veuillez enregistrer vos changements avant de renvoyer un email d'activation")
                return
            # console.log "RESEND ", @user.uid, user_is_active, user_is_not_activated , @user.email
            if @user.uid != '' and user_is_active and user_is_not_activated and @user.email != ''
                @$http.post(settings.resend_activation_email, {"user_uid":@user.uid})
                .then (resp)->
                    if resp.body.status == "ok"
                        n.success_message('Email envoyé')
                    else
                        n.error("users_profile: resend_activation_email: then", resp.body.message)
            else
                n.warning("Afin de renvoyer un email d'activation, le collaborateur doit pouvoir se connecter à l'application et avoir un email valide")

        get_user: ()->
            self = @
            @loading = true
            q.run('get_user', [@uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("users_profile: get_user: then", e.message)
                else
                    # console.log "GET USER : ", resp.body.data.app_user
                    self.user = resp.body.data.app_user
                    self.initial_is_active = resp.body.data.app_user.is_active
                    self.initial_email = resp.body.data.app_user.email
                    if self.user.parent == null
                        self.user.parent = {uid:'', fullname:'Aucun'}
                    roles = []
                    for role in self.user.roles
                        roles.push(role.uid)
                    self.user.roles = roles
                    if self.user.user_info.photo != ''
                        self.photo_url = settings.media_url+self.user.user_info.photo_dir+"/"+self.user.user_info.photo
                    if self.user.user_info.social_nbr.length > 0 and self.user.user_info.social_nbr.length != 15
                        self.errors['social_nbr'] = self.social_nbr_error
                    self.loading = false
                    # console.log "USER PROFILE MOUNTED", self.user.roles, self.roles
            .catch (resp)->
                n.catch_error(resp, "users_profile: get_user()")

        get_managers: ()->
            self = @
            # console.log "GET MANAGERS ", @$store.getters.current_company.uid
            q.run('get_manager_set', [@$store.getters.current_company.uid, @uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("users_profile: get_managers: then", e.message)
                else
                    # console.log "GET MANAGERS : ", resp.body.data.manager_set
                    self.managers.push({uid:'', fullnamejobs:'Aucun'})
                    self.managers = self.managers.concat(resp.body.data.manager_set)
                    if self.user.uid != ''
                        self.managers = self.managers.filter (x)->
                            x.uid != self.user.uid
            .catch (resp)->
                n.catch_error(resp, "users_profile: get_managers()")

        get_roles: ()->
            self = @
            q.run('get_users_profile_company_roles', [@$store.getters.current_company.uid, @uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("users_profile: get_roles: then", e.message)
                else
                    # console.log "GET ROLES : ", resp.body.data.users_profile_company_role_set
                    self.roles = resp.body.data.users_profile_company_role_set
            .catch (resp)->
                n.catch_error(resp, "users_profile: get_roles()")

        save: ()->
            self = @
            # console.log "USERS SAVE"
            if Object.keys(@errors).indexOf('social_nbr') != -1
                n.form_error()
                return
            m.run('save_app_user', [@user, @$store.getters.current_company.uid])
            .then (resp)->
                # console.log "APPUSER MUTATION RESPONSE", resp.body.data.app_user_form_mutation
                if resp.body.data.app_user_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.app_user_form_mutation.errors.length > 0
                    # console.log "ERRORS", resp.body.data.app_user_form_mutation.errors
                    self.errors = resp.body.data.app_user_form_mutation.errors.reduce(
                        (acc, el)->
                            acc[el.field] = el.messages
                            return acc
                    ,{})
                    n.form_error()
                else
                    self.errors = {}
                    n.success()
                    if self.user.uid == ''
                        new_uid = resp.body.data.app_user_form_mutation.form_ret
                        self.$store.commit('set_selected_app_user', {'uid':new_uid, 'lastname':self.user.user_info.lastname, 'firstname':self.user.user_info.firstname})
                        localStorage.setItem("selected_app_user", JSON.stringify(self.$store.state.selected_app_user))
                        self.$router.push({name:'company_users_informations', params:{uid:new_uid}})
                    else
                        self.get_user()
            .catch (resp)->
                n.catch_error(resp, "users_profile: save()")
            
    beforeMount: ()->
        # console.log "USERS PROFILE BEFORE MOUNT", @uid
        @get_roles()
        @get_managers()
        if @uid != '0'
            @get_user()
        else
            @loading = false
}
